<template>
  <section class="grid md:grid-cols-2 gap-10 px-2 lg:px-0">
    <div>
      <label class="text-gray-900 dark:text-gold-50 font-light"
        >Nedbetaling</label
      >
      <div class="mt-2.5">
        <vue-slider
          @change="(val) => change({ key: 'years', val })"
          v-model="years"
          tooltip="always"
          :tooltip-formatter="'{value} år'"
          :min="1"
          :max="10"
          :piecewise="true"
          :height="3"
          :dot-size="20"
          tooltip-dir="bottom"
        ></vue-slider>
      </div>
    </div>

    <div>
      <label class="text-gray-900 dark:text-gold-50 font-light"
        >Egenkapital</label
      >
      <div class="mt-2.5">
        <vue-slider
          @change="(val) => change({ key: 'capital', val })"
          v-model="selectedCapital"
          tooltip="always"
          :tooltip-formatter="'{value}%'"
          :min="0"
          :max="90"
          :height="3"
          :dot-size="20"
        ></vue-slider>
      </div>
    </div>
  </section>
</template>

<script>
import VueSlider from 'vue-slider-component';
import rates from '../data/rates';
import Helper from '../helper/FinancialHelper';

export default {
  name: 'FinancialCalculator',
  props: [
    'disclaimer',
    'price',
    'capital',
    'prevPrices',
    'registration',
    'nominal',
    'effective',
    'optionsSum',
    'prevOptionsSum',
    'typeCharge',
    'shouldUpdate',
    'funding',
    'financial',
    'currentColor',
  ],
  components: {
    VueSlider,
  },
  data: function () {
    const carRate = rates.standard;
    return {
      selectedCapital: this.capital,
      years: carRate.years,
      nominalInterest: this.nominal || window.interestRate,
      monthlyCost: carRate.monthlyCost,
      registrationCost: carRate.registrationCost,
      preparationFee: carRate.preparationFee,
      rates: carRate,
      calculationsInput: null,
      pricesInput: null,
    };
  },
  mounted() {
    this.assignLabels();
    this.assignDomNodes();
    this.$nextTick(() => {
      this.change();
    });
  },
  methods: {
    assignDomNodes() {
      this.calculationsInput = document.querySelector(
        '.input-car-calculations'
      );

      this.pricesInput = document.querySelector('.input-car-prices');
    },
    assignLabels() {
      document.querySelectorAll('.vue-slider-dot').forEach((el) => {
        el.setAttribute('aria-label', 'slider thumb');
      });
    },
    change(data) {
      const {
        years: initialYears,
        optionsSum,
        prevOptionsSum,
        registrationCost,
        preparationFee,
        nominalInterest,
        monthlyCost,
      } = this;

      const years = data && data?.key == 'years' ? data.val : initialYears;
      const dataCapital =
        data && data?.key == 'capital' ? data.val : this.selectedCapital;

      const price = +this.price + (optionsSum || 0);
      const prevPrice = this.prevPrices
        ? +this.prevPrices.price + (prevOptionsSum || 0)
        : 0;

      const capital = Helper.getCapital(+price, dataCapital);

      const realPrice = Helper.calculateRealPrice(
        +price,
        registrationCost,
        preparationFee,
        capital
      );

      const mndprice = Helper.calculateMonthlyPrice(
        realPrice,
        nominalInterest,
        years,
        monthlyCost
      );

      const effectiveInterest =
        this.nominal && this.effective
          ? this.effective
          : Helper.calculateEffectiveRate(
              realPrice,
              nominalInterest,
              years,
              monthlyCost,
              registrationCost,
              preparationFee
            );

      const totalPrice = mndprice * (years * 12) + capital;
      if (document.getElementById('financing-link')) {
        document
          .getElementById('financing-link')
          .setAttribute(
            'href',
            `https://billanforhandler.nfn.nordea.no/?branchid=821&pris=${price}&registreringsnummer=${this.registration}&nedbetalingstid=${years}&egenkapital=${capital}`
          );
      }

      if (this.calculationsInput) {
        const str = `TYPE: buy,  1. Years: ${years},  2: Capital: ${dataCapital} %`;
        this.calculationsInput.value = str;
      }

      if (this.pricesInput) {
        const f = this.$filters.formatNumber;
        this.pricesInput.value = `TYPE: buy,
        1. Price: ${f(price)},
        2. Monthly Price: ${f(mndprice)},
        3. Capital: ${f(capital)},
        4. Total Price: ${f(totalPrice)},
        5. Years: ${years},
        6. Effective Interest: ${f(effectiveInterest)},
        7. Normial Interest: ${f(nominalInterest)}`;
      }

      this.emitter.emit('update-calculations', {
        type: 'buy',
        price,
        prevPrice,
        mndprice,
        capital,
        totalPrice,
        years,
        effectiveInterest,
        nominalInterest,
        disclaimer: this.disclaimer || false,
      });
    },
  },
  watch: {
    price() {
      if (this.funding !== 'buy') return;
      this.change();
    },
    nominal() {
      this.nominalInterest = this.nominal || window.interestRate;
      this.change();
    },
    shouldUpdate() {
      this.change();
    },
    currentColor() {
      this.change();
    },
    optionsSum() {
      this.change();
    },
  },
};
</script>
